import Cookies from "js-cookie";

/**
 * Vendors write their cookies on the registrable domain (`.focal.mozn.sa`),
 * not the exact host, so a cookie is only removed when deleted with the same
 * domain attribute it was written with. Try the host-only form and every
 * parent domain.
 */
const candidateDomains = (hostname: string): (string | undefined)[] => {
	const labels = hostname.split(".");
	const parents = labels
		.slice(0, -1)
		.map((_, index) => labels.slice(index).join("."));
	return [undefined, ...parents];
};

const matchesPrefix = (name: string, prefixes: readonly string[]) =>
	prefixes.some((prefix) => name.startsWith(prefix));

const clearCookiesByPrefix = (prefixes: readonly string[]) => {
	const domains = candidateDomains(window.location.hostname);
	for (const name of Object.keys(Cookies.get())) {
		if (!matchesPrefix(name, prefixes)) continue;
		for (const domain of domains) {
			Cookies.remove(name, { path: "/", domain });
		}
	}
};

const clearWebStorageByPrefix = (prefixes: readonly string[]) => {
	for (const storage of [window.localStorage, window.sessionStorage]) {
		try {
			const keys = Array.from({ length: storage.length }, (_, index) =>
				storage.key(index),
			);
			for (const key of keys) {
				if (key && matchesPrefix(key, prefixes)) storage.removeItem(key);
			}
		} catch {
			// Storage can be unavailable (privacy mode, blocked site data).
		}
	}
};

/** Removes every cookie and web-storage entry a vendor wrote, by name prefix. */
const clearVendorStorage = (prefixes: readonly string[]) => {
	clearCookiesByPrefix(prefixes);
	clearWebStorageByPrefix(prefixes);
};

export { clearVendorStorage };
